import { getLabel } from '../../helpers';
import css from './OptionTitle.module.scss';

const OptionTitle = ({ option, searchValue }) => {
    const title = getLabel(option);

    const index = searchValue && typeof title === 'string' ? title?.toLowerCase().indexOf(searchValue.toLowerCase()) : -1;

    if (!searchValue || index === -1) {
        return <>{title}</>;
    }
    return (
        <span className={css.optionTitle}>
            <span className={css.greyColor}>{title.substring(0, index)}</span>
            <span>{title.substring(index, index + searchValue.length)}</span>
            <span className={css.greyColor}>{title.substring(index + searchValue.length)}</span>
        </span>
    );
};
export default OptionTitle;
